import { Controller } from 'stimulus';
import StickyFill from 'stickyfilljs';

class AboutController extends Controller {
  connect() {
    [this.stickyElement] = this.contentTarget.children;

    AboutController.initializeSticky();

    StickyFill.addOne(this.stickyElement);
  }

  disconnect() {
    if (typeof this.stickyElement !== 'undefined' && this.stickyElement) {
      StickyFill.removeOne(this.stickyElement);
    }
  }

  static initializeSticky() {
    // Polyfill position sticky even when the browser does support sticky. We
    // do this because native sticky doesn't allow sticky when inside overflow
    // containers. And there's no easy way to remove the overflow containers.
    StickyFill.forceSticky();

    StickyFill.refreshAll();
  }
}

AboutController.targets = [
  'content',
];

export default AboutController;
